'use client'

import Link from 'next/link'
import React from 'react'

import { cn } from '../../lib/utils'
import { Container } from '../layout/container'

export default function Footer() {
  const year = React.useMemo(() => new Date().getFullYear(), [])

  return (
    <footer className="bg-gradient-to-br from-white to-gray-50 dark:from-gray-900 dark:to-gray-1000">
      <Container className="relative py-8" size="small">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {/* Video Logo & Company Info */}
          <div className="flex flex-col items-center gap-4 md:items-start">
            <Link href="/" className="group flex items-center">
              <div className="relative flex">
                <video
                  width="120"
                  height="60"
                  className="rounded-lg transition-transform duration-300 group-hover:scale-105"
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="metadata"
                >
                  <source src="/output.webm" type="video/mp4" />
                </video>
              </div>
            </Link>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Data engineering across Australia and New Zealand
              <br />
              HQ: UOW Innovation Campus, North Wollongong NSW
            </p>
          </div>

          {/* Navigation */}
          <div className="text-center md:text-left">
            <h3 className="mb-4 text-sm font-semibold text-gray-900 dark:text-white">
              Quick Links
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  href="/about-us"
                  className="text-gray-600 hover:text-blue-600 dark:text-gray-400"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  href="/services"
                  className="text-gray-600 hover:text-blue-600 dark:text-gray-400"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  href="/contact-us"
                  className="text-gray-600 hover:text-blue-600 dark:text-gray-400"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Company Details */}
          <div className="text-center lg:text-right">
            <div className="text-sm text-gray-600 dark:text-gray-400">
              <ul className="space-y-2">
                <li>&copy; {year} Cloud Shuttle PTY LTD</li>
                <li>All rights reserved.</li>
                <li>HQ: UOW Innovation Campus, North Wollongong NSW 2500</li>
                <li>Sydney base: Stone &amp; Chalk Tech Central, Level 1/477 Pitt St, Haymarket NSW 2000</li>
                <li>ABN: 94 638 159 136</li>
              </ul>
            </div>
          </div>
        </div>
      </Container>
    </footer>
  )
}
